/*
 * Darci Messenger Web Client Application Config
 * Strictly isolated for Darci native ecosystem
 */

import type {TrueDcId} from '@types';
import langPackLocalVersion from '@/langPackLocalVersion';

export const MAIN_DOMAINS = ['darci.myclassrz.online', 'localhost', '127.0.0.1'];
export const DEFAULT_BACKGROUND_SLUG = 'pattern';

const threads = Math.min(4, navigator.hardwareConcurrency ?? 4);

const App = {
  id: 1,
  hash: 'darci_native_application_secret_hash',
  pushServerKey: '',
  version: '1.0.0',
  versionFull: '1.0.0 (Darci Native)',
  build: 1,
  langPackVersion: 1,
  langPackLocalVersion: langPackLocalVersion,
  langPack: 'android',
  langPackCode: 'fa',
  domains: MAIN_DOMAINS,
  baseDcId: 1 as TrueDcId,
  isMainDomain: true,
  suffix: 'Darci',
  threads,
  lottieWorkers: threads,
  cryptoWorkers: threads,
  interclientBroadcastChannel: 'darci_channel'
};

export default App;
